<script lang="ts">
	import DangerIcon from '$lib/atoms/badges/DangerIcon.svelte'
	import type { DangerKind } from '$types/enums'

	interface Props {
		name: string
		/** every reason this value makes the material dangerous */
		danger?: DangerKind[]
	}

	let { name, danger = [] }: Props = $props()

	const kinds = $derived([...new Set(Array.isArray(danger) ? danger : ([danger] as DangerKind[]))])
</script>

<!-- the slot is always reserved so the names stay aligned across rows -->
<div class="value-name">
	<span class="value-name-icons">
		<DangerIcon {kinds} />
	</span>
	{name}
</div>

<style>
	.value-name {
		display: flex;
		align-items: center;

		/* AnalysisTable shares these so its header keeps the same offset */
		gap: var(--value-icon-gap, 0.5rem);
	}

	.value-name-icons {
		display: inline-flex;
		align-items: center;
		min-width: var(--value-icon-slot, 2rem);
	}
</style>
